export const InterviewStyle = {

    variants: {
      wrapper: {
        '.results': {
          display: 'block',
          clear: 'both',
          marginTop: '1rem',
        },
        '.resultsInner': {
          padding: '1rem 1rem 1rem 2rem',
          whiteSpace: 'break-spaces',
          border: '1px solid #333',
          borderRadius: '10px',
          overflowY: 'auto',
          maxHeight: '500px',
        },
        '.hero': {
          display: 'flex',
          alignItems: 'center',
        },
        '.heroImage': {
          width: [0, 0, 0, 'auto'],
        },
        '.qHeading': {
          display: 'none !important',
        },
        '.interviewWrapper': {
          display: 'flex',
        },
        '.pfsNav': {
          margin:'0 auto',
          minWidth: '70%',
        },
        '.interviewFormWrapper': {
          width: '100%',
        },
        '.interviewCenter': {
          minHeight: [0, '400px', null, '500px'],
          padding: [0, 0, '2rem'],
          border:'1px solid #333',
          borderRadius: '5px',
        },
        '.interviewEditBox': {
          display:"flex",
          justifyContent:"space-evenly",
          marginTop:'1rem',
        },
        '.interviewEditInnerBox': {
          display:"flex",
          justifyContent:"space-evenly",
          alignItems:"center",
          width:'100%',
        },
        '.interviewBox': {
          maxWidth:'33%',
        },
        '.editButtonWrap': {
          display:"flex",
          justifyContent:"flex-end",
          marginTop: '1rem',
        },
        '.bold': {
          fontWeight:'bold',
          textTransform:'uppercase',
        },
      },
    },

  }
;

